import { DashboardsIcon } from 'App/dashboards/_components/DashboardsIcon'
import { useAccessibleDashboards } from 'App/dashboards/_utils/useAccessibleDashboards'
import { useIsDashboardsSupported } from 'App/dashboards/_utils/useIsDashboardsSupported'
import { Debug } from 'App/Map/LayerNav/Debug/Debug'
import { RecentlyAddedItem } from 'App/Map/LayerNav/Layers/generateNavigationMenu/RecentlyAddedItem/RecentlyAddedItem'
import { Divider } from 'components/SideNav/Divider/Divider'
import { IconAndTitle } from 'components/SideNav/IconAndTitle/IconAndTitle'
import { Preferences } from 'components/SideNav/Preferences/Preferences'
import { SectionTitle } from 'components/SideNav/SectionTitle/SectionTitle'
import { SideNav } from 'components/SideNav/SideNav'
import { translate } from 'i18n/i18n'
import { layersNavigationMenuStore } from 'stores/layersNavigationMenuStore/layersNavigationMenuStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { pushRoute } from 'utils/pushRoute'
import { Layers } from './Layers/Layers'
import { PresetLayers } from './PresetLayers/PresetLayers'
import { QuickLinks } from './QuickLinks/QuickLinks'

export const LayerNav = () => {
  const menuCollapsed = layersNavigationMenuStore.useSelector((s) => s.menuCollapsed)
  const enoughDataLoadedToShowTheUsualMenu = userDetailsStore.useSelector((s) => s.id)
  const isDashboardsSupported = useIsDashboardsSupported()
  // Hide the Dashboards entry entirely when the user has no dashboards to list (no pest with
  // degree-day or trap-catch access on any of their properties), so it mirrors the landing page.
  const hasAccessibleDashboards = useAccessibleDashboards().length > 0

  const handleToggleExpand = () => {
    layersNavigationMenuStore.setState((s) => ({ ...s, menuCollapsed: !menuCollapsed }))
  }

  return (
    <SideNav collapsed={menuCollapsed} onToggleExpand={handleToggleExpand}>
      {/* DASHBOARDS — desktop + iPad only, hidden on phones; also hidden when the user has none to list */}
      {!!enoughDataLoadedToShowTheUsualMenu && isDashboardsSupported && hasAccessibleDashboards && (
        <>
          <Divider />
          <IconAndTitle
            icon={<DashboardsIcon variant="filled" size={20} />}
            onClick={() => pushRoute('/dashboards')}
            title={<RecentlyAddedItem translatedTitle={translate.phrases.placeholder('Dashboards')} />}
          />
        </>
      )}

      {/* LAYERS */}
      {!!enoughDataLoadedToShowTheUsualMenu && (
        <>
          <Divider />
          <SectionTitle>{translate.phrases.banyanApp('LAYERS')}</SectionTitle>
          <PresetLayers />
          <Layers />
          <Divider />
          <SectionTitle>{translate.phrases.banyanApp('QUICK LINKS')}</SectionTitle>
          <QuickLinks />
          <Debug />
          <Divider />
          <SectionTitle>{translate.phrases.banyanApp('PREFERENCES')}</SectionTitle>
        </>
      )}
      <Preferences />
    </SideNav>
  )
}
